import script from "./DemoBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./DemoBanner.vue?vue&type=script&setup=true&lang=js"

import "./DemoBanner.vue?vue&type=style&index=0&id=4e582d6d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e582d6d"]])

export default __exports__